import * as React from 'react';
import styled from 'styled-components';

interface Props {
  className?: string;
  text: string;
  disabled: boolean;
  onClick: () => void;
  color: string;
  bgColor: string;
  opacity: string;
  style?: IObj;
  borderRadius?: string;
}

const Button = styled.div<{
  disabled: boolean;
  color: string;
  bgColor: string;
  opacity: string;
  borderRadius?: string;
}>`
  background: ${({ bgColor }) => bgColor};
  border-radius: ${({ borderRadius }) => (borderRadius ? borderRadius : 0)};
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 0.44em;
  min-height: 0.44em;
  color: ${({ color }) => color};
  letter-spacing: 0;
  opacity: ${({ disabled, opacity }) => (disabled ? opacity : 1)};
`;

export default (props: Props) => {
  const { text, ...rest } = props;
  return (
    <Button {...rest}>
      <div style={{ fontSize: '0.16em' }}>{text}</div>
    </Button>
  );
};
